export default class Openable {
    public isOpen = false

    public open() {
        this.isOpen = true
    }
    public close() {
        this.isOpen = false
    }

    public change() {
        this.isOpen = !this.isOpen
    }
}
